export default __webpack_public_path__ + "static/media/loading.f3296bb9.gif";